import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TablesService {
  constructor(private http: HttpClient) {}

  getAllTables(data) {
    return this.http.post(`${environment.apiUrl}/tables/all`, data).pipe();
  }

  createTable(data) {
    return this.http.post(`${environment.apiUrl}/table/create`, data).pipe();
  }

  updateTable(id, data) {
    return this.http
      .patch(`${environment.apiUrl}/table/update/${id}`, data)
      .pipe();
  }

  deleteTable(id) {
    return this.http.delete(`${environment.apiUrl}/table/delete/${id}`).pipe();
  }
}
